<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="SettingsInvoicing"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <DIV
    class="overflow-auto h-100 p-3"
    v-if="loaded"
  >
    <ItpBox
      alignItems="center"
      class="mb-3"
    >
      <strong>
        {{ 'Invoicing configuration'|pgettext('Settings') }}
      </strong>
      <ItpButton
        icon="fa-sync-alt"
        :text="'Reload'|gettext"
        variant="light"
        size="sm"
        :spinning="actions.reload.isRunning"
        class="ml-3"
        @click.prevent.stop="evh_8320016629450276_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
    <ItpDataTable
      tableId="Settings.Invoicing"
      editable
      :isRowEditable="p => !p.locked"
      :value="items"
      no-create-row
      no-delete-row
      :globs="{ configureNumbering, configureProvider }"
      :columns="b_3343864469950044_columns"
      class="h-100"
      ref="table"
      v-if="loaded"
      @save="evh_3343864469950044_save($event, {})"
    >
    </ItpDataTable>
  </DIV>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "settings.invoicing",
    path: "invoicing",
    component: "SettingsInvoicing"
  }
)

@Component()
export default class SettingsInvoicing extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  updateItem(...args: any[]) {
    const [data, extras] = args;

    return this.$fn.crud('invoicing_settings').update(
      _.extend(
        _.pick(data, [
          'company',
          'draft_numbering',
          'numbering',
          'invoicing_mode',
          'invoicing_provider',
          'template'
        ]),
        extras
      ),
      {
        parameters: { company_id: data.company.id }
      }
    )
  }

  onSave(...args: any[]) {
    const [$event] = args;
    const row = $event.data.row;

    return $event.data.waitFor(this.updateItem(row));
  }

  configureNumbering(...args: any[]) {
    const [value, row] = args;
    const updateItem = this.updateItem;

    return this.$imodal
      .show({
        name: 'InvoicingNumbering',
        props: {
          company: row.company,
          oid: value ? value.id : null,
          saving(numbering) {
            return updateItem(row, { numbering });
          }
        }
      })
  }

  configureProvider(...args: any[]) {
    const [value, row] = args;
    const updateItem = this.updateItem;

    return this.$imodal
      .show({
        name: 'InvoicingProviderSettings',
        props: {
          item: _.cloneDeep(value),
          saving(invoicing_provider) {
            return updateItem(row, { invoicing_provider });
          }
        }
      })
      .then(result => {
        if (result) {
          row.setData(result)
        }
      })
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_invoicing_settings').then(data =>
      _.orderBy(data, ['company.name']).map(p => _.extend(p, { id: p.company.id }))
    )
  }

  numberings!: any;

  async $$load_numberings() {
    return this.$fn.fetch('list_numbering').then(data => _.filter(data, { resource_type: 'invoice:out' }))
  }

  templates!: any;

  async $$load_templates() {
    return this.$fn.fetch('list_template').then(data => _.filter(data, { template_type: 'html', object_type: 'invoice' }))
  }

  invoicingModes!: any;

  async $$load_invoicingModes() {
    return this.$fn.getEnumValuesFromSchema('InvoicingMode')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_3343864469950044_columns!: any;

  async $$load_b_3343864469950044_columns() {
    return [{
      name: "company",
      field: "company.name",
      header: this.$fn.pgettext("Settings|TableHeader", "Company"),
      width: "200px",
      editable: false,
    }
      ,
    {
      name: "invoicing_mode",
      header: this.$fn.pgettext("Settings|TableHeader", "Invoicing mode"),
      width: "160px",
      type: "select2",
      options: this.invoicingModes,
      valueField: "value",
      textField: "text",
    }
      ,
    {
      name: "draft_numbering",
      header: this.$fn.pgettext("Settings|TableHeader", "Draft numbering"),
      width: "160px",
      type: "select2",
      options: this.numberings,
      textField: "description",
      path: "description",
      bindObject: true,
      clearable: true,
    }
      ,
    {
      name: "numbering",
      header: this.$fn.pgettext("Settings|TableHeader", "Numbering"),
      width: "160px",
      editable: false,
      formatter: {
        name: "template",
        value: "<a href=\"\" @click.prevent.stop=\"globs.configureNumbering(value, row)\">\n\
  <span class=\"text-nowrap\" v-if=\"value\">\n\
    {{ value.info.last_number }}\n\
  </span>\n\
  <span class=\"text-nowrap\" v-if=\"!value\">\n\
    unset\n\
  </span>\n\
</a>\n\
",
      }
      ,
    }
      ,
    {
      name: "invoicing_provider",
      header: this.$fn.pgettext("Settings|TableHeader", "Provider settings"),
      width: "160px",
      editable: false,
      formatter: {
        name: "template",
        value: "<a href=\"\" @click.prevent.stop=\"globs.configureProvider(value, row)\">\n\
  <span class=\"text-nowrap\" v-if=\"value\">\n\
    {{ value.name }}\n\
  </span>\n\
  <span class=\"text-nowrap\" v-if=\"!value\">\n\
    unset\n\
  </span>\n\
</a>\n\
",
      }
      ,
    }
      ,
    {
      name: "template",
      header: this.$fn.pgettext("Settings|TableHeader", "Template"),
      width: "160px",
      type: "select2",
      options: this.templates,
      path: "name",
      textField: "name",
      bindObject: true,
      clearable: true,
    }
      ,
    ]
  }

  dataMembers = ['items', 'numberings', 'templates', 'invoicingModes', 'ux', 'b_7315092382398562_modalBindings', 'b_3343864469950044_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        items: null,
        numberings: null,
        templates: null,
        invoicingModes: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_3343864469950044_columns: null,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return
    }
    return null;
  }

  async act_7315092382398562_closeModal_5594_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5594, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_8320016629450276_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_3343864469950044_script_5598_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_3343864469950044_script_5598, alias=undefined
    this.onSave($event)
  }

  async act_3343864469950044_script_5598_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_3343864469950044_script_5598, alias=undefined
    return {
      value: () => this.act_3343864469950044_script_5598_getActionArgs_value($event),
    }
  }

  async evh_3343864469950044_save(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3343864469950044_save.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5594: actions.CloseModalAction;
    evh_7315092382398562_close_5593: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_8320016629450276_reloadComponentData_5596: actions.ReloadComponentDataAction;
    evh_8320016629450276_clickPreventStop_5595: actions.EventHandlerImpl;
    evh_8320016629450276_clickPreventStop: actions.EventHandlerGroup;
    act_3343864469950044_script_5598: actions.ScriptAction;
    evh_3343864469950044_save_5597: actions.EventHandlerImpl;
    evh_3343864469950044_save: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5594 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5594_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5593 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5594,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5593],
      }
    );
    const act_8320016629450276_reloadComponentData_5596 = new actions.ReloadComponentDataAction(
      {
        displayName: "reload",
        events: [],
      }
    );
    const evh_8320016629450276_clickPreventStop_5595 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_reloadComponentData_5596,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_8320016629450276_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_clickPreventStop_5595],
      }
    );
    const act_3343864469950044_script_5598 = new actions.ScriptAction(
      {
        actionArgs: this.act_3343864469950044_script_5598_getActionArgs,
        events: [],
      }
    );
    const evh_3343864469950044_save_5597 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_script_5598,
        event: "save",
        displayName: "script",
      }
    );
    const evh_3343864469950044_save = new actions.EventHandlerGroup(
      {
        handlers: [evh_3343864469950044_save_5597],
      }
    );
    return {
      act_7315092382398562_closeModal_5594,
      evh_7315092382398562_close_5593,
      evh_7315092382398562_close,
      act_8320016629450276_reloadComponentData_5596,
      evh_8320016629450276_clickPreventStop_5595,
      evh_8320016629450276_clickPreventStop,
      act_3343864469950044_script_5598,
      evh_3343864469950044_save_5597,
      evh_3343864469950044_save,
      reload: act_8320016629450276_reloadComponentData_5596,
    }
  }
}

Vue.component("SettingsInvoicing", SettingsInvoicing);

</script>